import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import styles from "../../../../customer/styles/customerStyles.module.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { verifyTransaction } from "../../../../../api/transaction";
import InputField from "../../../../../Authentication/components/InputField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "20px 50px",
  borderRadius: "10px",
};

export default function VerifyTransactionModal({
  transactionId,
  tabStatus,
  amount,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [depositAmount, setDepositAmount] = useState(0);
  const [status, setStatus] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const dispatch = useDispatch();
  
  return (
    <>
      <Icon
        icon="material-symbols:edit-square-outline"
        width="20"
        height="20"
        style={{ cursor: "pointer", marginRight: "5px" }}
        onClick={handleOpen}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <>
              <h2
                className={styles.welcome_popup}
                style={{ marginBottom: "20px" }}
              >
                Verify Transaction
              </h2>
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Initial Deposit Amount
              </InputLabel>
              <InputField
                type="text"
                disabled
                max={amount}
                defaultValue={`€`+amount}
              />
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Accepted Deposit Amount
              </InputLabel>
              <InputField
                type="number"
                max={amount}
                placeholder="Enter amount"
                value={depositAmount}
                onChange={(e) => setDepositAmount(Number(e.target.value))}
              />
              {depositAmount > amount && (
                <h6
                  style={{ color: "tomato", marginTop: 5, textAlign: "left" }}
                >
                  Can’t accept more than available
                </h6>
              )}
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Select Status
              </InputLabel>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  sx={{
                    margin: "10px 0",
                    width: "100%",
                    textAlign: "left",
                    height: "46px",
                  }}
                  value={status || "Select status"}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem disabled value="Select status" selected>
                    Select
                  </MenuItem>
                  <MenuItem value="REJECTED">Reject</MenuItem>
                  <MenuItem value="SUCCESS">Accept</MenuItem>
                </Select>
              </FormControl>

              <Button
                variant="lightblue"
                disabled={status === "" || isClicked || depositAmount > amount}
                sx={{
                  width: "auto",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  if (!isClicked) {
                    setIsClicked(true);
                    dispatch(
                      verifyTransaction({
                        transactionId: transactionId,
                        status: tabStatus,
                        updatePayload: {
                          status: status,
                          depositAmount: depositAmount,
                        },
                      })
                    ).then(() => {
                      setIsClicked(false);
                      setDepositAmount(0);
                    });
                    handleClose();
                  }
                }}
              >
                Update
              </Button>
            </>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
